import { Notification } from "@hatch-digital-nl/abs-storybook/legacy";
import certificateAdded from "../../../../common/images/certificate_added.svg";
import certificateExpired from "../../../../common/images/certificate_expired.svg";
import { NotificationInterface } from "../../../../common/interfaces/NotificationInterface";
import { NotificationTypeEnum } from "../../../../common/enums/NotificationTypeEnum";
import editIcon from "../../../../common/images/edit-white.svg";
import refreshIcon from "../../../../common/images/refresh.svg";
import { JSX } from "react";

interface NotificationItemProps {
    notification: NotificationInterface;
    onClick?: () => void;
    isLoading: boolean;
}

export const NotificationItem = (props: NotificationItemProps): JSX.Element => {
    const { notification, onClick, isLoading } = props;

    const notificationArgs = {
        icon: {
            url:
                props.notification.badge.icon ===
                NotificationTypeEnum.CERTIFICATE_ADDED
                    ? certificateAdded
                    : certificateExpired,
            backgroundColor:
                notification.badge.icon ===
                NotificationTypeEnum.CERTIFICATE_ADDED
                    ? "#7CBF3F1A"
                    : "#E33F3F1A",
        },
        showButtons:
            notification.badge.icon ===
                NotificationTypeEnum.CERTIFICATE_EXPIRED ||
            (notification.badge.icon === NotificationTypeEnum.WARNING_RED &&
                notification.certificate?.approved === false),
        type: notification.badge.icon as
            "certificate_added" | "certificate_expired" | "warning-red",
        title: notification.title,
        date: notification.description,
        buttonIcon:
            notification.certificate?.approved === false
                ? editIcon
                : refreshIcon,
        buttonText:
            notification.certificate?.approved === false
                ? "Certificaat bewerken"
                : "Opnieuw toevoegen",
        onClick: onClick,
        isLoading: isLoading,
    };

    return <Notification {...notificationArgs} />;
};
